import { render, staticRenderFns } from "./ArtifactCard.vue?vue&type=template&id=bf527942&scoped=true&lang=pug&"
import script from "./ArtifactCard.vue?vue&type=script&lang=js&"
export * from "./ArtifactCard.vue?vue&type=script&lang=js&"
import style0 from "./ArtifactCard.vue?vue&type=style&index=0&id=bf527942&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf527942",
  null
  
)

export default component.exports